module.exports = __webpack_public_path__ + "static/media/CleanerPath.fc3e8d89.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PennAppsF18/CleanerPath.png
// module id = 145
// module chunks = 0